import TermInfo from "./TermInfo.tsx";
import ProgramBanner from "./ProgramBanner/ProgramBanner.tsx";
import { ExpandedCourse, useCoursesLoaderData } from "./coursesLoader.ts";
import Course from "./Course.tsx";
import { useIntl } from "react-intl";
import PageTitle from "routes/home/common/page-title/PageTitle.tsx";
import PrintReturnBanner from "./PrintReturn/PrintReturnBanner.tsx";
import useSurveyToast from "./useSurveyToast.tsx";
import DefaultTemplate from "routes/home/layout/content-templates/default/DefaultTemplate.tsx";
import VerifyShippingAddressBanner from "./VerifyShippingAddressBanner.tsx";
import styles from "./MyCourses.module.scss";
import CompareAndPurchaseCartButton from "./common/CompareAndPurchaseCartButton.tsx";
import VirtualStoreSystemMessage from "./VirtualStoreSystemMessage.tsx";
import TermOrdersBannerManager from "./TermOrdersBanner/TermOrdersBannerManager.tsx";
import useAlternateAccessDiagnostics from "./useAlternateAccessDiagnostics.ts";

export default function MyCourses() {
  const { courses, compareCart } = useCoursesLoaderData();
  const intl = useIntl();
  useSurveyToast();
  useAlternateAccessDiagnostics();
  const title = intl.formatMessage({ defaultMessage: "My Courses" });
  return (
    <DefaultTemplate
      title={title}
      headerConfig={{
        bonusButtons: <CompareAndPurchaseCartButton cart={compareCart} />,
        allowImpersonationBanner: true,
      }}
    >
      <PageTitle title={title} noHeading />
      <div>
        <ProgramBanner />
        <VirtualStoreSystemMessage />
        <TermInfo />
        <div className={styles.bannersContainer}>
          <PrintReturnBanner />
          <VerifyShippingAddressBanner />
          <TermOrdersBannerManager />
        </div>
        {!!courses.length &&
          courses.map((course: ExpandedCourse) => (
            <Course key={course.id} {...course} />
          ))}
      </div>
    </DefaultTemplate>
  );
}
